export enum EGameName {
    JACKPOT_SLOTS = 'jackpot-slots',
    BIG_FISH_CASINO = 'big-fish-casino'
}

export enum EGradientDirection {
    TopToBottom = 'to bottom',
    BottomToTop = 'to top',
    LeftToRight = 'to right',
    RightToLeft = 'to left',
    TopLeftToBottomRight = 'to bottom right',
    BottomRightToTopLeft = 'to top left',
    TopRightToBottomLeft = 'to bottom left',
    BottomLeftToTopRight = 'to top right'
}

export enum EFontWeights {
    Normal = 'normal',
    Bold = 'bold',
    Bolder = 'bolder'
}

export enum EBundlesInternalViewModel {
    AK = 'ak',
    MATCH = 'match',
    COMMUNIX = 'communix',
    MAIN_SUB = 'mainSub',
    MAIN_SUB_ALT = 'mainSubAlt',
    zero = 'zero',
    BAGLECODE = 'bagelcode',
    LOCO_BINGO = 'locobingo'
}

export enum EProductType {
    TIME = 'Time',
    QUANTITY = 'Quantity'
}

export enum EProductPriority {
    MAIN = 'Main',
    SUB = 'Sub'
}

export enum EBadgePosition {
    LEFT = 'left',
    RIGHT = 'right',
    TOP = 'top',
    BOTTOM = 'bottom',
    CENTER = 'center',
    TOP_LEFT = 'top-left',
    TOP_RIGHT = 'top-right',
    TOP_CENTER = 'top-center',
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_RIGHT = 'bottom-right',
    BOTTOM_CENTER = 'bottom-center',
    CENTER_CENTER = 'center-center'
}

export enum EBadgeType {
    EMBLEM = 'emblem',
    RIBBON = 'ribbon',
    SALE = 'sale'
}

export enum ELoginMode {
    PROVIDERS = 'providers',
    USERNAME = 'username',
    TOKEN_ID = 'tokenId',
    OTP = 'otp'
}

export enum ELoginMethods {
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    APPLE = 'apple',
    USERNAME = 'userPassword',
    TOKEN = 'userToken',
    OTP = 'otp'
}

export enum EPlatformType {
    IOS = 'ios',
    ANDROID = 'android',
    WEB = 'web'
}

export enum EAppleResponseType {
    CODE = 'code',
    ID_TOKEN = 'code id_token'
}

export enum EOTPModel {
    STATIC = 'static',
    DYNAMIC_LINK = 'dynamicLink'
}

export enum EOTPTextModel {
    SIX_DIGITS = 'sixDigits',
    FOUR_DIGITS = 'fourDigits'
}

export enum ELoginEvents {
    LOGIN_CANCELED = 'LOGIN_CANCELED',
    LOGIN_SCREEN_PRESENTED = 'LOGIN_SCREEN_PRESENTED',
    LOGIN_APPROVAL = 'LOGIN_APPROVAL',
    LOGIN_BUTTON_CLICKED = 'LOGIN_BUTTON_CLICKED',
    LOGIN_OTP_IOS_BUTTON = 'LOGIN_OTP_IOS_BUTTON',
    LOGIN_OTP_ANDROID_BUTTON = 'LOGIN_OTP_ANDROID_BUTTON',
    OTP_BUTTON_CLICKED = 'OTP_BUTTON_CLICKED',
    OTP_CODE_ENTERED = 'OTP_CODE_ENTERED',
    PLAYER_ID_BUTTON_CLICKED = 'PLAYER_ID_BUTTON_CLICKED',
    PLAYER_PASSWORD_BUTTON_CLICKED = 'PLAYER_PASSWORD_BUTTON_CLICKED'
}

export enum ESessionStorageKeys {
    REDIRECT_STATE = 'redirectState'
}

export enum ESalePercentageDisplayType {
    PERCENTAGE = 'percentage',
    MULTIPLIER = 'multiplier',
    FIXED_AMOUNT = 'fixed_amount'
}
